
import React, { useState } from 'react';
import { Listprops } from './type';
import classNames from 'classnames';
import './style.less'

const ActiveList: React.FC<Listprops> = (props) => {
    const { modelData = [] } = props;
    const [firstStatus, setFirstStatus] = useState(true);
    return (
        <div className="list-map">

            {
                modelData.map((item, index) => {
                    return (

                        <div className={classNames((index === 0 && firstStatus) ? "list-div-sel" : "list-div")} tabIndex={index} onClick={() => { setFirstStatus(false) }}>

                            <div className="list-word">{item.item}</div>
                            <div className="list-tag">{item.wordtag_label}</div>
                            <div className="list-operation">
                                {item?.termid ?? ''}
                            </div>
                        </div>


                    )
                })
            }



        </div>
    );
};

export default ActiveList;
